const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5100/api';
const ACCESS_TOKEN_KEY = 'hppl_export_admin_access_token';
let accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);

export const setAccessToken = token => {
  accessToken = token;
  if (token) localStorage.setItem(ACCESS_TOKEN_KEY, token);
  else localStorage.removeItem(ACCESS_TOKEN_KEY);
};

async function parseResponse(response) {
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(result.message || 'Request failed');
    error.status = response.status;
    error.details = result.errors || [];
    throw error;
  }
  return result;
}

export async function refreshSession() {
  const response = await fetch(`${API_URL}/auth/refresh`, { method: 'POST', credentials: 'include' });
  const result = await parseResponse(response);
  setAccessToken(result.accessToken);
  return result;
}

export async function apiRequest(path, options = {}, retry = true) {
  const isFormData = options.body instanceof FormData;
  const headers = { ...(!isFormData && { 'Content-Type': 'application/json' }), ...options.headers };
  if (accessToken) headers.Authorization = `Bearer ${accessToken}`;
  const response = await fetch(`${API_URL}${path}`, { ...options, headers, credentials: 'include' });
  if (response.status === 401 && retry && path !== '/auth/refresh') {
    try {
      await refreshSession();
      return apiRequest(path, options, false);
    } catch (_) {
      setAccessToken(null);
    }
  }
  return parseResponse(response);
}
